import { eTipoPermissao } from '@/enums/ePermissoes';

/*
 * RESPONSÁVEL DO ESTUDANTE POR TURMA — migração de `MenuAcademico/ResponsavelAlunoTurma.aspx`: a
 * grade da turma inteira para lançar/corrigir de uma vez o responsável (nome, CPF, sexo e dois
 * telefones) de cada estudante.
 *
 * Permissão PRÓPRIA (300100699), vizinha da legada (300100600).
 */
export default [
  {
    description: 'Responsável do Estudante por Turma',
    path: '/academico/responsavelturma',
    name: 'responsavel_estudante_turma',
    component: () => import('@/views/academico/responsavelturma/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.RESPONSAVELESTUDANTEPORTURMANOVO_MENU_300100699],
    },
    goesToMenu: true,
  },
];
